import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Container from "../components/Container";
import SectionTitle from "../components/Home/SectionTitle";
import { useSiteContent } from "../context/SiteContentContext";

function ArticleBlock({ text }) {
  if (text.startsWith("-")) {
    return (
      <li className="mr-5 pr-2 text-[17px] leading-9 text-[#4b4034]">
        {text.replace(/^-\s*/, "")}
      </li>
    );
  }

  return <p className="text-[17px] leading-9 text-[#4b4034]">{text}</p>;
}

export default function Fasting() {
  const [article, setArticle] = useState("");
  const { tables } = useSiteContent();

  useEffect(() => {
    fetch("/data/fasting.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`تعذر تحميل مقالة الصوم: ${response.status}`);
        }

        return response.json();
      })
      .then((data) => setArticle((data.body || "").trim()))
      .catch((error) => console.error(error));
  }, []);

  const { title, blocks } = useMemo(() => {
    const parts = article
      .split(/\r?\n\s*\r?\n/)
      .map((part) => part.trim())
      .filter(Boolean);

    return {
      title: parts[0] ?? "لماذا الصوم",
      blocks: parts.slice(1),
    };
  }, [article]);

  return (
    <main className="pb-20">
      <section className="pb-8 pt-10">
        <Container>
          <div className="rounded-[32px] bg-[#f3eee5] px-6 py-10 text-right md:px-10 lg:flex lg:items-end lg:justify-between">
            <div className="max-w-3xl">
              <p className="text-sm font-bold text-[#8a7355]">مقالات روحية</p>
              <SectionTitle title={title} classes="mt-3 text-[#3e352b]" />
              <p className="mt-4 max-w-2xl text-[16px] leading-7 text-[#5d5348]">
                نص روحي عن معنى الصوم وارتباطه بالصلاة والتوبة والمحبة.
              </p>
            </div>

            <Link
              to="/information"
              className="mt-6 inline-flex rounded-full border border-[#8a7355] px-5 py-3 text-sm font-bold text-[#5d5348] transition-colors hover:bg-[#8a7355] hover:text-white lg:mt-0"
            >
              العودة إلى معلومات الرعية
            </Link>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <article className="rounded-[32px] border border-[#eadfce] bg-white p-6 text-right shadow-[0_18px_60px_rgba(76,58,37,0.08)] md:p-10">
            {article ? (
              <div className="mx-auto max-w-5xl space-y-6">
                {blocks.map((block, index) => {
                  const lines = block
                    .split(/\r?\n/)
                    .map((line) => line.trim())
                    .filter(Boolean);
                  const isList = lines.every((line) => line.startsWith("-"));

                  if (isList) {
                    return (
                      <ul key={`${index}-${block.slice(0, 20)}`} className="space-y-3">
                        {lines.map((line) => (
                          <ArticleBlock key={line} text={line} />
                        ))}
                      </ul>
                    );
                  }

                  return (
                    <ArticleBlock
                      key={`${index}-${block.slice(0, 20)}`}
                      text={block}
                    />
                  );
                })}
              </div>
            ) : (
              <div className="rounded-[24px] bg-[#fcfaf6] px-5 py-4 text-right text-[#5d5348]">
                {tables.emptyLabel}
              </div>
            )}
          </article>
        </Container>
      </section>
    </main>
  );
}
